import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';
//import { Alert } from "react-bootstrap";




const NavBar = ({countryCode, onGround, setCountryCode, setOnGround }) => {

    const geoURL = "https://opensky-network.org/api/states/all"
    //const geoURL = "fakelink"
    const [countryList, setCountryList] = useState([]);
    // const [selectedCountry, setSelectedCountry] = useState(setCountryCode);
    // const [flyingStatus, setFlyingStatus] = useState(onGround ? "OnGround" : "Flying");

    useEffect(() => {
        const fetchData = async () => {
        let data;
          try {
            // 尝试从API获取数据
            const response = await fetch(geoURL); // 此处的"fakelink"应替换为实际API链接
            if (!response.ok) throw new Error("Network response was not ok");
            data = await response.json();
            //console.log("Real data fetched from API:", data);
            processCountryData(data);
          } 
          catch (error) {
            // 在出错时使用本地假数据
            //console.error("Failed to fetch data from API, using fake data instead:", error);
            data = await import('../fakeplanes.json')
            data = data.default
            //console.log("Using local fake data:", data); 
            processCountryData(data); // 使用导入的假数据
          }
        };
    
        const processCountryData = (data) => {
          const countryCounts = {};
          data.states.forEach(item => {
            const countryName = item[2];
            if (countryCounts[countryName]) {
              countryCounts[countryName] += 1;
            } else {
              countryCounts[countryName] = 1;
            }
          });
    
          const sortedCountries = Object.keys(countryCounts)
            .map(country => ({
              name: country,
              count: countryCounts[country]
            }))
            .sort((a, b) => b.count - a.count)
            .slice(0, 10)
            .map(country => country.name);
    
          setCountryList(sortedCountries);
        };
    
        fetchData();
      }, [countryCode, onGround]);


        const handleCountrySelect = (country) => {
            //setSelectedCountry(country); // 更新选中的国家
            setCountryCode(country); // 更新父组件状态
        };

        const handleFlyingStatusSelect = (status) => {
            //setFlyingStatus(status ? "OnGround" : "Flying"); // 更新飞行状态显示
            setOnGround(status); // 更新父组件状态
        };


        return (
            <Navbar expand="lg" bg="dark" variant="dark">
              <Container>
                <Navbar.Brand href="#home">Global FlightMap</Navbar.Brand>
                <Navbar.Text className="custom-text">Please Select the Country and Flight States</Navbar.Text> 
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="me-auto">

                    <Dropdown >
                        <Dropdown.Toggle className="custom-button" variant="success" id="dropdown-basic" defaultValue={"Canada"}>
                            {countryCode}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                                {countryList.map(country => (
                                    <Dropdown.Item key={country} onClick={() => handleCountrySelect(country)}>{country}</Dropdown.Item>
                                ))}
                        </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown>
                        <Dropdown.Toggle className="custom-button" variant="success" id="dropdown-basic">
                            {onGround ? 'Grounded' : 'Airborne'}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item key="Flying"  onClick={() => handleFlyingStatusSelect(false)}>Airborne</Dropdown.Item>
                            <Dropdown.Item key="OnGround" onClick={() => handleFlyingStatusSelect(true)}>Grounded</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>


                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          );
}

export default NavBar